import { LitElement, css, html } from 'lit';
import { customElement, property, query } from 'lit/decorators';

import { Fab } from '@material/mwc-fab';
import { StateController } from '../helpers/state/state-management/state-controller';
import pointCache from '../helpers/state/point-cache';
import topicData from '../helpers/state/topic-data';

type ButtonMode = 'hidden' | 'fab' | 'text';

@customElement('add-point-button')
export class AddPointButton extends LitElement {
    amplitude_callsite: string = 'Add Point';

    @query('#addPointButton')
    addPointButton!: Fab;

    @property({ type: String })
    buttonMode: ButtonMode = 'text';

    openAddPointModal() {
        this.dispatchEvent(new CustomEvent('open-add-point'));
    }

    openUpgradeModal() {
        this.dispatchEvent(new CustomEvent('open-upgrade'));
    }

    private readonly bindPointCacheState = new StateController(this, pointCache);

    private renderTextButton() {
        return html`
            ${pointCache.pointsRemaining <= 0 ? html`
                <button @click=${this.openUpgradeModal} class="add-point-button--text red">
                    <mwc-icon class="add-point-button--text-icon">add_location</mwc-icon>
                    <translated-span>Add ${topicData.topic?.point_name ?? 'Point'}</translated-span>
                </button>
            ` : html`
            <button @click=${this.openAddPointModal} class="add-point-button--text">
                <mwc-icon class="add-point-button--text-icon">add_location</mwc-icon>
                <translated-span>Add ${topicData.topic?.point_name ?? 'Point'}</translated-span>
            </button>
            `}
        `;
    }

    protected render() {
        return html`
            ${this.buttonMode === 'text' ?
                this.renderTextButton()
            : ''}
        `;
    }

    static get styles() {
        return css`
            .add-point-button--text {
                display: flex;
                flex-direction: column;
                align-items: center;
                color: var(--theme-input-color);
                width: 60px;
                background-color: var(--main-featured-color);
                border: 0;
                padding: 8px;
                cursor: pointer;
            }

            .red {
                background-color: var(--main-invalid-color);
            }

            .add-point-button--text-icon {
                padding-bottom: 4px;
            }

            .add-point-button--icon {
                --mdc-theme-secondary: var(--main-success-color) !important;
                --mdc-theme-on-secondary: var(--theme-white-color) !important;
            }
        `;
    }
}
